import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import MainOperationsDashboard from './pages/main-operations-dashboard';
import SmartCertificateExpiryManagement from './pages/smart-certificate-expiry-management';
import ComprehensiveReportsAnalyticsDashboard from './pages/comprehensive-reports-analytics-dashboard';
import PropertiesManagementScreen from './pages/properties-management-screen';
import MaintenanceKanbanWorkflowBoard from './pages/maintenance-kanban-workflow-board';
import TenantOnboardingManagementScreen from './pages/tenant-onboarding-management-screen';
import EnhancedDashboardHomeWithAlertManagement from './pages/enhanced-dashboard-home-with-alert-management';
import UniversalSidePanelDetailSystem from './pages/universal-side-panel-detail-system';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<MainOperationsDashboard />} />
        <Route path="/main-operations-dashboard" element={<MainOperationsDashboard />} />
        <Route path="/smart-certificate-expiry-management" element={<SmartCertificateExpiryManagement />} />
        <Route path="/comprehensive-reports-analytics-dashboard" element={<ComprehensiveReportsAnalyticsDashboard />} />
        <Route path="/properties-management-screen" element={<PropertiesManagementScreen />} />
        <Route path="/maintenance-kanban-workflow-board" element={<MaintenanceKanbanWorkflowBoard />} />
        <Route path="/tenant-onboarding-management-screen" element={<TenantOnboardingManagementScreen />} />
        <Route path="/enhanced-dashboard-home-with-alert-management" element={<EnhancedDashboardHomeWithAlertManagement />} />
        <Route path="/universal-side-panel-detail-system" element={<UniversalSidePanelDetailSystem />} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
